import { r as registerInstance, h, H as Host, g as getElement } from './index-8f7fb048.js';
import { o as observeAriaAttributes } from './aria-f37957bf.js';

const marketLinkCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{--transition-duration:0.2s;font-weight:var(--text-link-medium-size-text-weight);font-size:inherit;line-height:inherit;letter-spacing:var(--text-link-medium-size-text-tracking);cursor:pointer}:host a,:host a:link,:host a:visited,:host a:hover,:host a:active,:host button{color:var(--text-link-normal-variant-color);font-family:inherit;text-decoration:none;transition:opacity var(--transition-duration)}:host a,:host a:link,:host a:visited,:host button{opacity:var(--text-link-normal-state-opacity)}:host a:hover,:host button:hover{opacity:var(--text-link-hover-state-opacity)}:host a:active,:host button:active{opacity:var(--text-link-pressed-state-opacity)}:host([aria-disabled]) a,:host([aria-disabled]) button{opacity:var(--text-link-disabled-state-opacity)}:host([destructive]) a,:host([destructive]) a:link,:host([destructive]) a:visited,:host([destructive]) a:hover,:host([destructive]) a:active,:host([destructive]) button{color:var(--text-link-destructive-variant-color)}:host button{padding:0;border:none;background:none;outline:inherit;font:inherit;cursor:pointer}";

const MarketLink = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.onMutationObserved = (ariaAttributes) => {
      this.ariaAttributes = ariaAttributes;
    };
    this.href = undefined;
    this.target = undefined;
    this.rel = undefined;
    this.destructive = false;
    this.disabled = false;
    this.ariaAttributes = undefined;
  }
  componentWillLoad() {
    this.mutationObserver = observeAriaAttributes(this.el, this.onMutationObserved);
  }
  handleClick(e) {
    if (this.disabled) {
      e.preventDefault();
      e.stopPropagation();
    }
  }
  render() {
    const { disabled, handleClick, href, target, ariaAttributes, rel } = this;
    const TagType = href !== undefined ? 'a' : 'button';
    const TagTypeAttrs = TagType === 'a' ? { href, target, rel } : { disabled };
    const ariaRole = TagType === 'a' ? 'link' : 'button';
    return (h(Host, { class: "market-link", role: ariaRole, "aria-disabled": disabled ? 'true' : null, tabindex: disabled ? '-1' : null, onClick: handleClick, onKeyDown: handleClick }, h(TagType, Object.assign({}, TagTypeAttrs, ariaAttributes, { "aria-disabled": disabled ? 'true' : null }), h("slot", null))));
  }
  disconnectedCallback() {
    var _a;
    (_a = this.mutationObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
  }
  get el() { return getElement(this); }
};
MarketLink.style = marketLinkCss;

export { MarketLink as market_link };
